import styled from 'styled-components'
import React, { useState } from 'react'
import theme from './theme'
import { Link } from 'react-router-dom'
import Icon from './Icon'

const ButtonComponent = ({
                           disabled,
                           children,
                           href,
                           to,
                           onClick,
                           ...props
                         }) => {
  const [loading, setLoading] = useState(false)

  let clickButton = async () => {
    if (onClick) {
      setLoading(true)
      const resp = await onClick()
      if (!resp) {
        setLoading(false)
      }
    }
  }
  const isDisabled = disabled || loading
  if ((href || to) && isDisabled) {
    if (disabled) {
      let className = props.className || ''
      className += ' disabled'
      props.className = className
      clickButton = () => {
      }
    }
    return <a onClick={ clickButton } { ...props }>
      { children }
      { loading && <Icon name="loading"/> }
    </a>
  }
  if (href) {
    return <a href={ href } onClick={ clickButton } { ...props }>
      { children }
    </a>
  }
  if (to) {
    return <Link to={ to } onClick={ clickButton } { ...props }>
      { children }
    </Link>
  }
  return (
    <button { ...props } disabled={ disabled } onClick={ clickButton }>
      { children }
      { loading && <Icon name="loading"/> }
    </button>
  )
}

const Button = styled(ButtonComponent)`
  font-weight: bold;
  background: ${ props => props.color ? props.color : theme.palette.dark_blue };
  color: ${ theme.palette.white };
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  border: 2px solid ${ props => props.color ? props.color : theme.palette.dark_blue };
  border-radius: 4px;
  white-space: nowrap;
  padding: 5px 20px;
  font-family: 'ParisineOffice', 'Helvetica Neue', sans-serif;
  font-size: 12px;
  line-height: 14px;
  

  svg {
    fill: ${ theme.palette.white };
    margin-left: 5px;
    height: 14px;
  }
  .loading {
    margin-left: 10px;
  }
  &:hover{
    opacity: 0.9;
  }
  &.disabled, &:disabled {
    border: 2px solid ${ theme.palette.grey };
    background-color: ${ theme.palette.grey };
  }
  &.inverse {
    background-color: ${ theme.palette.white };
    color: ${ props => props.color ? props.color : theme.palette.dark_blue };
    border: 2px solid ${ props => props.color ? props.color : theme.palette.dark_blue };
  }
  &.secondary {
    background-color: ${ theme.palette.light_grey };
    color: ${ props => props.color ? props.color : theme.palette.black };
    border: 2px solid ${ props => props.color ? props.color : theme.palette.light_grey };
  }
  &.clear {
    font-weight: normal;
    font-size: 12px;
    line-height: 14px;
    padding: 0;
    background: transparent;
    text-decoration: underline;
    border: 0;
    color: ${ props => props.color ? props.color : theme.palette.black };
  }
`

export default Button
